var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaved = function SvgSaved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#saved_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M29.65 35.297 18 31.06 6.352 35.297V2.82c0-1.17.948-2.118 2.118-2.118H27.53c1.17 0 2.119.948 2.119 2.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M18 20.467A8.469 8.469 0 1 0 18 3.53a8.469 8.469 0 0 0 0 16.938"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M14.795 11.915a1.764 1.764 0 0 1 0-2.504 1.78 1.78 0 0 1 1.257-.518c.456 0 .91.172 1.258.518l.69.687.69-.687a1.785 1.785 0 0 1 2.516 0 1.76 1.76 0 0 1 0 2.504L18 15.105z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M11.293 23.295h13.414M11.293 27.53h13.414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "saved_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgSaved;